// import axios from 'axios';

// const baseURI = 'http://localhost:8081';

const folderStoreModule = {
  // namespaced: false,

  state: {
    folderList: Array,
    fileList: Array,
  },
  mutations: {
    'SET_STORE_FOLDER_LIST' (state, folderList) {
      state.folderList = folderList;
    },
    'SET_STORE_FILE_LIST' (state, fileList) {
      state.fileList = fileList;
    },
  },
  actions: {
    getFolderList: async ({commit}) => {
      // await axios.get(baseURI + "/company/list").then((response) => {
      //   console.log(response.data);
      //   commit('SET_STORE_MONITOR_LIST', response.data);
      // }).catch((ex) => {
      //   console.log(ex);
      // });

      let data = [
        {
          id: '01',
          name: 'from FTP for HLCU',
          children: [
            {
              id: '02',
              name: 'inbox_bkg_confirm_hlcu',
            },
            {
              id: '03',
              name: 'inbox_tracking_hlcu',
            },
          ],
        },
        {
          id: '04',
          name: 'from FTP for YMLU',
          children: [
            {
              id: '05',
              name: 'inbox_bkg_confirm_ymlu',
            },
            {
              id: '06',
              name: 'inbox_tracking_ymlu',
            },
          ],
        },
        {
          id: '07',
          name: 'for INTTRA',
          children: [
            {
              id: '08',
              name: 'inbox',
            },
            {
              id: '09',
              name: 'inbox_test',
            },
            {
              id: '10',
              name: 'outbox',
            },
            {
              id: '11',
              name: 'outbox_test',
            },
          ],
        },
      ];

      commit('SET_STORE_FOLDER_LIST', data);
    },
    getFileList: async ({commit}) => {
      // await axios.get(baseURI + "/company/list").then((response) => {
      //   console.log(response.data);
      //   commit('SET_STORE_MONITOR_LIST', response.data);
      // }).catch((ex) => {
      //   console.log(ex);
      // });

      let data = [
        {
          id: '1',
          name: 'inbox_bkg_confirm_hlcu',
          type: 'D',
          ext: 'folder',
          size: '(2 Files)',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '2',
          name: 'inbox_tracking_hlcu',
          type: 'D',
          ext: 'folder',
          size: '(0 File)',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '3',
          name: 'IFTMBC_20191107.csv',
          type: 'F',
          ext: 'csv',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '4',
          name: 'IFTMBC_20191107.xml',
          type: 'F',
          ext: 'xml',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '5',
          name: 'IFTMBC_20191107.edi',
          type: 'F',
          ext: 'edifact',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '6',
          name: 'IFTMBC_20191107.edi',
          type: 'F',
          ext: 'edifact',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '7',
          name: 'IFTMBC_20191107.edi',
          type: 'F',
          ext: 'edifact',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '8',
          name: 'Booking Confirm.pdf',
          type: 'F',
          ext: 'pdf',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '9',
          name: 'IFTMBC_20191107.csv',
          type: 'F',
          ext: 'csv',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '10',
          name: 'IFTMBC_20191107.xml',
          type: 'F',
          ext: 'xml',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '11',
          name: 'IFTMBC_20191107.edi',
          type: 'F',
          ext: 'edifact',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '12',
          name: 'IFTMBC_20191107.edi',
          type: 'F',
          ext: 'edifact',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '13',
          name: 'IFTMBC_20191107.edi',
          type: 'F',
          ext: 'edifact',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '14',
          name: 'Booking Confirm.pdf',
          type: 'F',
          ext: 'pdf',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '15',
          name: 'IFTMBC_20191107.csv',
          type: 'F',
          ext: 'csv',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
        {
          id: '16',
          name: 'IFTMBC_20191107.xml',
          type: 'F',
          ext: 'xml',
          size: '131KB',
          creDt: '2020-01-02 12:45:28',
          modDt: '2020-01-02 12:45:28',
        },
      ];

      commit('SET_STORE_FILE_LIST', data);
    },
  },
  getters: {
    folderList: state => state.folderList,
    fileList: state => state.fileList,
  },
};

export default folderStoreModule;